export const UPDATE_ACTIVE_LOCALES = 'UPDATE_ACTIVE_LOCALES';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export const ADD_APP_VERSION_INFORMATION = 'ADD_APP_VERSION_INFORMATION';
const ADD_APP_USER_ACCOUNTS = 'ADD_APP_USER_ACCOUNTS';

const initialState = {
  versionInfor: {},
  user: {},
};

export const addVersionInfor = (versionInfor = {}) => ({
  type: ADD_APP_VERSION_INFORMATION,
  versionInfor,
});

export const addAccountList = (accounts = []) => ({
  type: ADD_APP_USER_ACCOUNTS,
  accounts,
});

export const addUserData = (userData = {}) => ({
  type: UPDATE_USER_INFO,
  userData,
});

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APP_VERSION_INFORMATION:
      return { ...state, versionInfor: action.versionInfor };
    case UPDATE_USER_INFO:
      return { ...state, user: action.userData };
    case UPDATE_ACTIVE_LOCALES:
      return { ...state, locales: action.locales };
    case ADD_APP_USER_ACCOUNTS:
      return { ...state, userAccounts: action.accounts };
    default:
      return state;
  }
};

export default appReducer;
